module.exports = __webpack_public_path__ + "static/media/pic10.56d5bfc1.jpg";